import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static readonly values = {
    targetInputSelector: String,
  };

  declare readonly targetInputSelectorValue: string;
  declare readonly hasTargetInputSelectorValue: boolean;

  private _targetInputElement: HTMLInputElement | null = null;

  connect(): void {
    if (this.hasTargetInputSelectorValue) {
      this._targetInputElement = document.querySelector(
        this.targetInputSelectorValue
      );
    }
  }

  remove(event: Event) {
    event.preventDefault();

    if (this._targetInputElement) {
      this._targetInputElement.value = `${true}`;
    }

    this.element.remove();
  }
}
